import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { PageHero } from "./AboutPage";
import { Reveal } from "../components/Reveal";
import { useLang } from "../context/LanguageContext";

export default function FaqPage() {
  const { t } = useLang();
  const [openIdx, setOpenIdx] = useState(0);
  const items = t("faq.items");

  return (
    <div className="bg-[#FAF7F2] min-h-screen" data-testid="faq-page">
      <Header />
      <PageHero overline={t("faq.overline")} title={t("faq.title")} sub={t("faq.sub")} testid="faq-title" img="/assets/svc-training.jpg" />
      <section className="pb-28 px-6 sm:px-12">
        <div className="max-w-3xl mx-auto space-y-4">
          {items.map((f, i) => {
            const open = openIdx === i;
            return (
              <Reveal key={i} delay={i * 0.04}>
                <div className={`card-light overflow-hidden ${open ? "border-[#E8842C]/60" : ""}`} data-testid={`faq-item-${i}`}>
                  <button
                    data-testid={`faq-question-${i}`}
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 px-6 py-5 text-start"
                  >
                    <span className="font-head font-bold text-[#1B2A4E]">
                      <span className="text-[#E8842C] font-black me-2" dir="ltr">{String(i + 1).padStart(2, "0")}.</span>
                      {f.q}
                    </span>
                    <span className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center transition-all duration-300 ${open ? "bg-[#E8842C] text-white rotate-45" : "bg-[#1B2A4E]/8 text-[#1B2A4E]"}`}>
                      <Plus className="w-4 h-4" />
                    </span>
                  </button>
                  <AnimatePresence initial={false}>
                    {open && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      >
                        <p className="px-6 pb-6 text-sm text-[#1B2A4E]/65 leading-relaxed" data-testid={`faq-answer-${i}`}>{f.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
      <Footer />
    </div>
  );
}
